export const EMPLOYEE_PERFORMANCE_PAGE = {
  LEARNING: "learning",
  TRAINING: "traning",
  SKILL: "skill",
  ASSESSMENT_RESULTS: "assessment_results",
};

export const EMPLOYEE_PERFORMANCE_PAGE_LIST = Object.values(
  EMPLOYEE_PERFORMANCE_PAGE
);
